type WsEventName =
  | "WsOpen"
  | "WsClose"
  | "WsError"
  | "WsTokenExpired"
  | "WsTokenRefreshSuccess"
  | "WsTokenRefreshFailed";

type WsEventAttrs = {
  attempt?: number;
  code?: number;
  reason?: string;
  wasClean?: boolean;
  isReconnect?: boolean;
  tokenExpired?: boolean;
  refreshErrorClass?: string;
  refreshErrorMessage?: string;
};

export type NrEventName = "AuthTokenRefreshSuccess" | "AuthTokenRefreshFailed" | "AuthForcedLogout";

export type NrEventAttrs = {
  source?: "proactive" | "reactive";
  attempt?: number;
  errorMessage?: string;
  errorClass?: string;
};

const addPageAction = <TName extends string, TAttrs extends Record<string, unknown>>(
  name: TName,
  attrs: TAttrs = {} as TAttrs,
): void => {
  if (typeof window === "undefined") return;

  const nr = (window as any).newrelic;
  if (!nr || typeof nr.addPageAction !== "function") return;

  nr.addPageAction(name, attrs);
};

export const trackWsEvent = addPageAction<WsEventName, WsEventAttrs>;
export const trackNrEvent = addPageAction<NrEventName, NrEventAttrs>;

/**
 * Safely send an error to NewRelic.
 * All errors sent via this method will appear in the Errors Inbox and count towards the errors for the agent/app.
 *
 * @param {string} err The error message
 * @param {Record<string, any>} extra Additional data to include in the error to NR
 * @returns void
 */
export const noticeError = (err: unknown, extra: Record<string, any> = {}): void => {
  if (typeof window === "undefined") return;

  const nr = (window as any).newrelic;
  if (!nr || typeof nr.noticeError !== "function") return;

  nr.noticeError(err, extra);
};
